import React from "react";
import InlineEdit from "@atlaskit/inline-edit";
import { ExtendedFieldProps } from "@atlaskit/inline-edit/dist/types/types";

import { Box } from "../../UI/Box";
import { TextField } from "../../UI/TextField";
import { COLOR_ATHENS_GRAY, COLOR_IRON } from "../../constants/styles";

interface IProps {
  value: string;
  onConfirm: (value: string) => void;
}

const valudateEditInput = (value: string) => {
  if (value.length === 0) {
    return "Update input can't be empty";
  }

  if (value.length > 20) {
    return "Must be less than 20 characters long";
  }
};

const editView = ({ errorMessage, ...fieldProps }: ExtendedFieldProps<string>) => (
  <TextField {...fieldProps} autoFocus width={70} />
);

const readView = (value: string) => () => (
  <Box
    height={40}
    display="flex"
    minWidth={40}
    px={1}
    alignItems="center"
    justifyContent="center"
    bgcolor={COLOR_ATHENS_GRAY}
    border={`1px solid ${COLOR_IRON}`}
  >
    {value}
  </Box>
);

export const RoomLabel: React.FC<IProps> = (props) => (
  <InlineEdit
    editView={editView}
    defaultValue={props.value}
    validate={valudateEditInput}
    onConfirm={props.onConfirm}
    readView={readView(props.value)}
  />
);
